import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { uiActions } from "store";
import { AnyNote, ErrorResponse, NoteService } from "types";

import useNoteService from "./useNoteService";

export type OnSuccess = (result?: AnyNote) => any;
export type OnError = (error?: ErrorResponse) => void;

type UseNoteModalProps = {
	key: string;
	service: NoteService;
	onAddSuccess?: OnSuccess;
	onAddError?: OnError;
};

type ShowAddNoteModalProps = {
	entityId: string;
	title?: string;
};

const useNoteModal = ({
	key,
	service,
	onAddSuccess,
	onAddError,
}: UseNoteModalProps) => {
	const dispatch = useDispatch();

	const { useAddNoteMutation } = useNoteService({
		key,
		service,
	});

	const { mutateAsync: addNote } = useAddNoteMutation({
		onSuccessCb: onAddSuccess,
		onErrorCb: onAddError,
	});

	const showNotesModal = useCallback(
		({ entityId, title = "View Deal Note" }) => {
			dispatch(
				uiActions.showModal("VIEW_NOTES", {
					entityId,
					title,
					value: key,
					service,
				}),
			);
		},
		[dispatch, key, service],
	);

	const showAddNoteModal = useCallback(
		({ entityId, title = "Add Deal Note" }: ShowAddNoteModalProps) =>
			dispatch(
				uiActions.showModal("NOTE_FORM", {
					title,
					addNote: note => addNote({ note, entityId }),
				}),
			),
		[addNote, dispatch],
	);

	return { showAddNoteModal, showNotesModal };
};

export default useNoteModal;
